export const CALLOUT_TOOL_ID = "callout";

const drawCallout = ({ ctx, point, number, penColor, penSize }) => {
  const radius = Math.max(10, penSize * 3);

  ctx.save();

  ctx.beginPath();
  ctx.arc(point.x, point.y, radius, 0, Math.PI * 2);
  ctx.fillStyle = "rgba(255, 255, 255, 0.96)";
  ctx.fill();

  ctx.lineWidth = Math.max(2, penSize * 0.9);
  ctx.strokeStyle = penColor;
  ctx.stroke();

  ctx.fillStyle = penColor;
  ctx.font = `700 ${Math.max(12, radius)}px Arial`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(String(number), point.x, point.y + 0.5);

  ctx.restore();
};

export const calloutToolConfig = {
  id: CALLOUT_TOOL_ID,
  usesPreview: false,
  cursor: "crosshair",
  onStart: () => true,
  onMove: () => {},
  onEnd: ({ ctx, endPoint, getNextCalloutNumber, penColor, penSize }) => {
    drawCallout({
      ctx,
      point: endPoint,
      number: getNextCalloutNumber(),
      penColor,
      penSize,
    });
  },
};

const CalloutToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === CALLOUT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(CALLOUT_TOOL_ID)}
      title="Numbered Callout"
      aria-label="Numbered Callout"
    >
      ①
    </button>
  );
};

export default CalloutToolButton;
